import { Button, Form, Input, message } from 'antd';
import axios from 'axios';
import React from 'react'
import useAuth from '../hooks/useAuth';

const URL = process.env.REACT_APP_API_URL;
const FeedbackToDevelopers = () => {

    const { auth } = useAuth();
    const { token } = useAuth();
    console.log('token: ', token);

    const [form] = Form.useForm(); // optional, for resetting later

    const handleSubmit = async (values) => {
        // console.log('Sending to backend:', values);
        // console.log('Form instance:', form);

        try {
         
           
            await axios.post(`${URL}/api/hiring-manager/query`, {
                name: auth.fullName,
                role: auth.role,
                email: auth.email,
                query:values.query,
            });

        } catch (err) {
            console.log('Error: ', err)
            message.error('Error submitting your query...')
        }

        message.success('Query Submitted Successfully...')

        form.resetFields();
    }


    // const [formData, setFormData] = useState({
    //     hiringManagerName: '',
    //     query: '',
    // });
    // const { TextArea } = Input;

    // const handleSubmit = () => {

    //     if (!formData.hiringManagerName || !formData.query) {
    //         message.error('Please fill out all the mandatory fields.')
    //     }

    //     console.log('Hi Universe');
    // }

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData(prevData => ({ ...prevData, [name]: value }));
    // }

    return (
        <>
            <Form
                onFinish={handleSubmit}
                form={form}
            >
                <Form.Item
                    label="Name"
                    name="hiringManager"
                    rules={[{ required: true, message: 'Please enter your name' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Your Query"
                    name="query"
                    rules={[{ required: true, message: 'Please enter your query' }]}
                >
                    <Input.TextArea rows={3} />
                </Form.Item>

                <Button type="primary" htmlType='submit'>
                    Submit
                </Button>
            </Form>
        </>
    )
}

export default FeedbackToDevelopers;